<template>
  <Transition name="rp">
    <div
      v-if="state.visible"
      class="route-progress"
      role="progressbar"
      aria-label="ページを読み込んでいます"
      :aria-valuenow="Math.round(state.progress)"
      aria-valuemin="0"
      aria-valuemax="100"
    >
      <div class="route-progress-bar" :style="{ width: state.progress + '%' }"></div>
    </div>
  </Transition>
</template>

<script setup>
import { useRouteProgress } from "@/composables/useRouteProgress";

const { state } = useRouteProgress();
</script>

<style scoped>
/* 画面最上端の 2px バー。ナビバー(z-index 1005)の上に重ねる。
   遷移中に出るものなので View Transitions のスナップショットから切り離す */
.route-progress {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  z-index: 1010;
  pointer-events: none;
  view-transition-name: route-progress;
}
.route-progress-bar {
  height: 100%;
  background: var(--c-accent-text);
  box-shadow: 0 0 6px var(--c-accent-text);
  transition: width 0.25s ease;
}
.rp-leave-active {
  transition: opacity 0.2s ease;
}
.rp-leave-to {
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  .route-progress-bar,
  .rp-leave-active {
    transition-duration: 0s;
  }
}
</style>
